import { Tabs, TabsContentGroupProps } from '@chakra-ui/react';
import { forwardRef, ReactNode } from 'react';
import { withPositionalTabValues } from './withPositionalTabValues';

export interface MTabPanelsProps extends TabsContentGroupProps {
  children?: ReactNode;
}

/*
 * v3 has no `TabPanels`-equivalent slot that auto-tracks position the way
 * v2's did — `Tabs.ContentGroup` is purely a styling wrapper. Same
 * positional-value assignment as `MTabList`; the two lists line up because
 * both are ordered identically, matching v2's implicit contract between
 * `TabList`/`TabPanels`.
 */
export const MTabPanels = forwardRef<HTMLDivElement, MTabPanelsProps>(
  ({ children, ...rest }, ref) => (
    <Tabs.ContentGroup ref={ref} {...rest}>
      {withPositionalTabValues(children)}
    </Tabs.ContentGroup>
  ),
);

MTabPanels.displayName = 'MTabPanels';

export default MTabPanels;
